
export default {
  data() {
    return {
      options: [
        { name: "title", label: "Title", type: "text" },
        { name: "description", label: "Description", type: "tipTap" },
        { name: "icon", label: "Icon", type: "image" },
      ],
    };
  },
};
